import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  events: [],
  lastEventId: null,
  lastDate: null,
  timeHeaders: [],
  tennisEvents: [],
  tennisLastEventId: null,
  tennisLastDate: null,
  tennisTimeHeaders: [],
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    aGetEventsSuccess: (state, action) => {
      state.events = action.payload.events;
      state.timeHeaders = action.payload.timeHeaders;
      state.lastEventId = action.payload.lastEventId;
      state.lastDate = action.payload.lastDate;
    },
    aGetTennisEventsSuccess: (state, action) => {
      state.tennisEvents = action.payload.tennisEvents;
      state.tennisTimeHeaders = action.payload.tennisTimeHeaders;
      state.tennisLastEventId = action.payload.tennisLastEventId;
      state.tennisLastDate = action.payload.tennisLastDate;
    },
    aBookUnbookEventsSuccess: (state, action) => {
      state.events = action.payload.events;
    },
    aBookUnbookTennisEventsSuccess: (state, action) => {
      state.tennisEvents = action.payload.events;
    },
  },
});

export const {
  aGetEventsSuccess,
  aGetTennisEventsSuccess,
  aBookUnbookEventsSuccess,
  aBookUnbookTennisEventsSuccess,
} = eventSlice.actions;

export default eventSlice.reducer;

